import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(SpinnerService);
  loaderService.show();
  return next(req).pipe(
    finalize(() => loaderService.hide())
  );
};
